// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"5b587e0fb20a252f7fc5","122":"16de5d5941e0181e35dc","123":"41548327842c65e84ce1","171":"778330b4797c43f47fc4"}[chunkId] + ".chunk.js";
};